<template>
  <section class="error">
    <img class="error-img" src="@/assets/images/error.png" alt="" />
    <span class="error-text">Not found</span>
  </section>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.error {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #202227;
  background-size: cover;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
  }
}
.error-img {
  position: relative;
  z-index: 2;
  max-width: 50%;
}
.error-text {
  position: relative;
  z-index: 2;
  font-size: 32px;
  color: #f5f5f5;
  margin-top: 32px;
  filter: drop-shadow(2px 2px 0px #111111);
}
@media screen and (min-width: 1024px) {
  .error {
  }
  .error-img {
    width: 22.22%;
  }
}

@media not all and (min-width: 1024px) {
  .error-img {
    width: 395px;
  }
  .error-text {
    font-size: 64px;
  }
}
</style>
